import { render, staticRenderFns } from "./OurSolutionPartner.vue?vue&type=template&id=201d7c0e&scoped=true&"
import script from "./OurSolutionPartner.vue?vue&type=script&lang=js&"
export * from "./OurSolutionPartner.vue?vue&type=script&lang=js&"
import style0 from "./OurSolutionPartner.vue?vue&type=style&index=0&id=201d7c0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d7c0e",
  null
  
)

export default component.exports